@if (announcement()) {
  <p-card class="custom-card">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div class="md:col-span-1">
        <div class="field-label">Identyfikator</div>
        <div class="field-value">{{ announcement()!.id }}</div>
      </div>
      <div class="md:col-span-2">
        <div class="field-label">Data utworzenia</div>
        <div class="field-value">
          {{ announcement()!.createdAt | date: 'yyyy-MM-dd HH:mm:ss' }}
        </div>
      </div>
    </div>

    <div class="mt-6">
      <div class="field-label">Tytuł</div>
      <div class="field-value">{{ announcement()!.title }}</div>
    </div>

    <div class="mt-6">
      <div class="field-label">Treść</div>
      <div
        class="field-value announcement-content ql-editor whitespace-pre-line break-all"
        [innerHTML]="announcement()!.content | textResource | async | safeHtml"
      ></div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
      <div>
        <div class="field-label">Status</div>
        <div class="field-value">
          <span [ngClass]="statusPillClass(announcement()!.status)">
            {{ statusLabel(announcement()!.status) }}
          </span>
        </div>
      </div>
      <div>
        <div class="field-label">Kanał</div>
        <div class="field-value">
          {{ channelLabel(announcement()!.channel) }}
        </div>
      </div>
      @if (shouldShowSystemFields()) {
        <div>
          <div class="field-label">Wymaga potwierdzenia</div>
          <div class="field-value">
            {{
              requiresConfirmationLabel(announcement()!.requiresConfirmation)
            }}
          </div>
        </div>
      }
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
      @if (shouldShowSystemFields()) {
        <div>
          <div class="field-label">Data rozpoczęcia</div>
          <div class="field-value">
            {{ announcement()!.startDate | date: 'yyyy-MM-dd HH:mm' }}
          </div>
        </div>
        <div>
          <div class="field-label">Data wygaśnięcia</div>
          <div class="field-value">
            {{ announcement()!.endDate | date: 'yyyy-MM-dd HH:mm' }}
          </div>
        </div>
      }
      @if (shouldShowEmailFields()) {
        <div>
          <div class="field-label">
            Planowana data wysłania wiadomości mailowych
          </div>
          <div class="field-value">
            {{ announcement()!.plannedEmailSendAt | date: 'yyyy-MM-dd HH:mm' }}
          </div>
        </div>
      }
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
      <div>
        <div class="field-label">Typ adresata</div>
        <div class="field-value">
          {{ recipientTypeLabel(announcement()!.recipientType) }}
        </div>
      </div>
      @if (shouldShowRecipients()) {
        <div>
          <div class="field-label">Adresat</div>
          <div class="field-value space-y-1">
            @for (
              recipient of announcement()!.recipients ?? [];
              track recipient.email
            ) {
              <div
                [pTooltip]="
                  !recipient.announcementsEmailConsent
                    ? 'Użytkownik nie wyraził zgody na otrzymywanie komunikatów za pomocą środków komunikacji elektronicznej.'
                    : undefined
                "
                [tooltipDisabled]="recipient.announcementsEmailConsent"
                tooltipPosition="top"
              >
                {{ recipient.email }}, {{ recipient.firstName }}
                {{ recipient.lastName }}
              </div>
            }
          </div>
        </div>
      }
      @if (shouldShowRequestType()) {
        <div>
          <div class="field-label">Kod wniosku</div>
          <div class="field-value">
            {{ announcement()!.requestCode ?? '-' }}
          </div>
        </div>
      }
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
      <div>
        <div class="field-label">Utworzył</div>
        <div class="field-value">{{ announcement()!.createdBy }}</div>
      </div>
      @if (announcement()!.publishedAt) {
        <div>
          <div class="field-label">Data opublikowania</div>
          <div class="field-value">
            {{ announcement()!.publishedAt | date: 'yyyy-MM-dd HH:mm:ss' }}
          </div>
        </div>
      }
    </div>
  </p-card>

  <div class="flex flex-wrap justify-end gap-2 mt-6">
    @if (announcement()!.status === AnnouncementStatus.ROBOCZY) {
      <p-button
        label="Wstecz"
        styleClass="customInfoButton outlined"
        (click)="onBack()"
      />
      <p-button
        label="Edytuj"
        styleClass="customInfoButton outlined"
        (click)="onEdit()"
      />
      <p-button
        label="Opublikuj"
        styleClass="customInfoButton"
        (click)="onPublish()"
      />
    } @else if (announcement()!.status === AnnouncementStatus.OPUBLIKOWANY) {
      <p-button
        label="Archiwizuj"
        styleClass="customInfoButton outlined"
        (click)="onArchive()"
      />
      <p-button
        label="Pokaż stan odczytania komunikatu przez użytkowników"
        styleClass="customInfoButton outlined"
        (click)="onShowReadStatus()"
      />
      <p-button
        label="Wstecz"
        styleClass="customInfoButton outlined"
        (click)="onBack()"
      />
    } @else {
      <p-button
        label="Wstecz"
        styleClass="customInfoButton outlined"
        (click)="onBack()"
      />
    }
  </div>
}
